import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const newsApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetNews();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (news: CreDtos.News) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostNews();
        query.news = news;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/news.service.ts